<span (click)="handleOrderingChange()" class="sorting-th" title="{{ title }}">
  <span class="pr-1" [innerHTML]="title"></span>
  <span class="sorting-th-controls">
    <span [class.show]="isInOrdering(fieldName)" class="material-symbols-rounded pl-1 arrow-upward">keyboard_arrow_up</span>
    <span [class.show]="isInOrdering('-' + fieldName)" class="material-symbols-rounded pl-1">keyboard_arrow_down</span>
  </span>
</span>
